export interface AppHelp {
  demoShown: boolean;
  introShown: boolean;
}

export const appHelpModel: AppHelp = {
  demoShown: false,
  introShown: false,
};
